<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="就诊人列表"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <!-- <div class="empty" v-if="emptyflag">  
<van-empty description="暂无就诊卡信息" />
    </div> -->
    <empty
      image="https://account.kmmds.top/datainfo_pic/error.png"
      v-if="emptyflag"
      @btnClick="onClickRight"
    ></empty>
    <div class="cell">
      <div
        class="item"
        size="large"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="cell_item">
          <div class="title">{{ item.clientName }}</div>
          <div class="value">{{ item.medCardNo }}</div>
        </div>
        <div class="cell_item">
          <div class="value">tel: {{ item.phoneNumber }}</div>
          <!-- class="btn_mini_style" -->
          <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click="Dialog(item.clientName, item.medCardNo, item)"
              >选择</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import empty from "@/components/empty.vue";
export default {
  data() {
    return {
      cardList: "",
      path: "",
      source: 1,
      showbtn: false,
      emptyflag: false,
      healthCardflag: null,
    };
  },
  components: {
    Nav,
    empty,
  },
  mounted() {
    this.getclientId();
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  methods: {
    async gethealthCardflag() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/healthcardcontroller/gethealthCardflag";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.healthCardflag = data.data;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //获取
    async getclientId() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/getclientcardlist";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // 添加就诊卡按钮显示
            this.cardList = data.data;

            let cardinfo = this.cardList[0];
            if (data.data.length === 1) {
              this.$router.push({
                path: this.path,
                query: {
                  name: this.cardList[0].clientName,
                  clientId: this.cardList[0].medCardNo,
                  item: cardinfo,
                },
              });
            }
            if (data.data.length > 4) {
              this.showbtn = false;
            } else {
              this.showbtn = true;
            }
            if (data.data.length === 0) {
              this.gethealthCardflag();
              this.emptyflag = true;
            } else if (data.data.length > 0) {
              this.emptyflag = false;
            }
            // console.log(data.data);

            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    //跳转新建绑卡页
    onClickRight() {
      // this.$router.push({
      //   path: this.healthCardflag?"/HealthcardList":"/patient_card_bind_C",
      //   query: {

      //   },
      // });
      const obj = {
        path: this.healthCardflag ? "/HealthcardList" : "/patient_card_bind_C"
      }
      this.$router.push(obj);
    },
    //确认事件
    Dialog(name, clientId, item) {
      let time = new Date().getFullYear();
      let age = time - Number(item.birthday.substr(0, 4));

      let a_name = name;
      this.$dialog
        .confirm({
          message: "确认选择用户:" + name,
        })
        .then(() => {
          // on confirm
          console.log(this.path);
          //把名字传回上一页面
          this.$router.push({
            path: this.path,
            query: {
              name,
              clientId,
              item,
              age,
            },
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss">
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar__title {
  color: white;
}
.van-nav-bar__text {
  color: white;
}
.van-nav-bar {
  background-color: #5b8df6;
}
.nav {
  letter-spacing: 5px;
}
.van-nav-bar__left,
.van-nav-bar__right {
  font-size: 25px;
}
.main {
  width: 100%;
  height: 100vh;
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    .item {
      display: flex;
      flex-direction: column;
      padding-top: 16px;
      padding-bottom: 16px;
      &::after {
        border-bottom: 0;
      }
      margin-bottom: 15px;
      background-color: #f7f8fa;
      box-shadow: 0 8px 12px #ebedf0;
      border-radius: 8px;
      .cell_item {
        width: 93%;
        line-height: 40px;
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        justify-content: space-between;
        .title {
          font-size: 18px;
          color: #323233;
        }
        .value {
          font-size: 16px;
          color: #555;
        }
        .label {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
}
.submit {
  margin: 0px 0px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .bottom_button {
    width: 90%;
    margin: 0px auto;
    border: 0px;
    background-color: #5b8df6;
    border-radius: 999px;
    height: 50px;
    color: white;
    letter-spacing: 10px;
    font-size: 14px;
  }
}
.submit .bottom_button {
  border-radius: 10px;
}
</style>